<template>
  <div class="help">
    <Nav :subNav="'帮助中心'" :isShowBack="1"></Nav>

    <div class="aboutJdxb-wrap">
      <div class="aboutJdxb">
        <div class="about">
          <div class="back" @click="goClick" v-if="false">
            <div class="back-icon"></div>
            返回
          </div>
          <div class="title" v-if="false">帮助中心</div>
          <div class="left">
            <div class="l-list">
              <CascaderItem
                :tree="list"
                :treeIndex="1"
                @nodeClick="nClick"
              ></CascaderItem>
            </div>
          </div>
          <div class="right" id="right">
            <div class="position-wrap">
              <div class="position-text1">
                {{ positionText.name ? positionText.name : "" }}
              </div>
              <div
                class="position-text2-wrap"
                v-if="positionText && positionText.children"
              >
                <div
                  class="position-text2"
                  v-for="(item, index) in positionText.children"
                  :key="index"
                  @click="nClick(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <InstallControled
              v-if="
                positionText &&
                positionText.parentid &&
                positionText.parentid == 101
              "
              :currentid="positionText.id"
            ></InstallControled>
            <InstallControl
              v-if="
                positionText &&
                positionText.parentid &&
                positionText.parentid == 102
              "
              :currentid="positionText.id"
            ></InstallControl>
            <BindControled
              v-if="positionText && positionText.id && positionText.id == 103"
            ></BindControled>
            <NasDesk
              @vipGuideClick="vipGuideClick"
              v-if="positionText && positionText.id && positionText.id == 201"
              :currentid="positionText.id"
            ></NasDesk>
            <RemoteDownload
              v-if="positionText && positionText.id && positionText.id == 205"
              :currentid="positionText.id"
            ></RemoteDownload>
            <RemoteVideo
              v-if="positionText && positionText.id && positionText.id == 206"
              :currentid="positionText.id"
            ></RemoteVideo>
            <RemoteFile
              v-if="positionText && positionText.id && positionText.id == 207"
              :currentid="positionText.id"
            ></RemoteFile>
            <RemotePhoto
              v-if="positionText && positionText.id && positionText.id == 208"
              :currentid="positionText.id"
            ></RemotePhoto>
            <JellyService
              v-if="positionText && positionText.id && positionText.id == 209"
              :currentid="positionText.id"
            ></JellyService>
            <EmbyService
              v-if="positionText && positionText.id && positionText.id == 210"
              :currentid="positionText.id"
            ></EmbyService>
            <RemoteRouter
              @vipGuideClick="vipGuideClick"
              v-if="positionText && positionText.id && positionText.id == 202"
            ></RemoteRouter>
            <RemoteDesk
              v-if="
                positionText &&
                positionText.parentid &&
                positionText.parentid == 203
              "
              :currentid="positionText.id"
            ></RemoteDesk>
            <RemoteOpen
              v-if="positionText && positionText.id && positionText.id == 204"
            ></RemoteOpen>
            <VipService
              v-if="positionText && positionText.id && positionText.id == 3"
            ></VipService>
            <Tools
              v-if="
                positionText &&
                positionText.parentid &&
                positionText.parentid == 4
              "
              :currentid="positionText.id"
            ></Tools>
            <Questions
              @remoteOpenClick="remoteOpenClick"
              v-if="
                positionText &&
                positionText.parentid &&
                positionText.parentid == 5
              "
              :currentid="positionText.id"
            ></Questions>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Common/Nav.vue";
import CascaderItem from "@/components/CascaderItem.vue";
import InstallControled from "@/components/answer/InstallControled.vue";
import InstallControl from "@/components/answer/InstallControl.vue";
import BindControled from "@/components/answer/BindControled.vue";
import NasDesk from "@/components/answer/NasDesk.vue";
import RemoteRouter from "@/components/answer/RemoteRouter.vue";
import RemoteDesk from "@/components/answer/RemoteDesk.vue";
import RemoteOpen from "@/components/answer/RemoteOpen.vue";
import RemoteDownload from "@/components/answer/RemoteDownload.vue";
import RemoteVideo from "@/components/answer/RemoteVideo.vue";
import RemoteFile from "@/components/answer/RemoteFile.vue";
import RemotePhoto from "@/components/answer/RemotePhoto.vue";
import EmbyService from "@/components/answer/EmbyService.vue";
import JellyService from "@/components/answer/JellyService.vue";
import VipService from "@/components/answer/VipService.vue";
import Tools from "@/components/answer/Tools.vue";
import Questions from "@/components/answer/Questions.vue";

export default {
  components: {
    Nav,
    CascaderItem,
    InstallControled,
    InstallControl,
    BindControled,
    NasDesk,
    RemoteRouter,
    RemoteDesk,
    RemoteOpen,
    VipService,
    Tools,
    Questions,
    RemoteDownload,
    RemoteVideo,
    RemoteFile,
    RemotePhoto,
    JellyService,
    EmbyService,
  },
  data: function () {
    return {
      //菜单结构
      list: [
        {
          id: 5,
          name: "常见问题",
          children: [
            {
              id: 501,
              parentid: 5,
              name: "手机号已被绑定",
            },
            {
              id: 502,
              parentid: 5,
              name: "传输速率如何",
            },
            {
              id: 503,
              parentid: 5,
              name: "何获取绑定码",
            },
            {
              id: 504,
              parentid: 5,
              name: "支持的设备厂商/型号/平台",
            },
            {
              id: 505,
              parentid: 5,
              name: "无法访问服务/访问白屏",
            },
            {
              id: 506,
              parentid: 5,
              name: "如何申请发票",
            },
            {
              id: 507,
              parentid: 5,
              name: "积分兑换问题",
            },
          ],
        },
        {
          id: 1,
          name: "安装与绑定",
          children: [
            {
              id: 101,
              parentid: 1,
              name: "安装设备端",
              children: [
                {
                  id: 10101,
                  parentid: 101,
                  name: "安装设备端-群晖-Synology",
                },
                {
                  id: 10102,
                  parentid: 101,
                  name: "安装设备端-铁威马-TreeaMaster",
                },
                {
                  id: 10103,
                  parentid: 101,
                  name: "安装设备端-威联通-QNAP",
                },
                {
                  id: 10104,
                  parentid: 101,
                  name: "安装设备端-联想-LENOVO",
                },
                {
                  id: 10105,
                  parentid: 101,
                  name: "安装设备端-海康-HIKVISION",
                },
                {
                  id: 10106,
                  parentid: 101,
                  name: "安装设备端-Windows",
                },
                {
                  id: 10107,
                  parentid: 101,
                  name: "安装设备端-Mac",
                },
              ],
            },
            {
              id: 102,
              parentid: 1,
              name: "安装客户端",
              children: [
                {
                  id: 10201,
                  parentid: 102,
                  name: "客户端-Web",
                },
                {
                  id: 10202,
                  parentid: 102,
                  name: "客户端-Windows",
                },
                {
                  id: 10203,
                  parentid: 102,
                  name: "客户端-Mac",
                },
                {
                  id: 10204,
                  parentid: 102,
                  name: "客户端-Android",
                },
                {
                  id: 10205,
                  parentid: 102,
                  name: "客户端-iOS",
                },
                {
                  id: 10206,
                  parentid: 102,
                  name: "客户端-小程序",
                },
              ],
            },
            {
              id: 103,
              parentid: 1,
              name: "绑定设备端设备",
            },
          ],
        },
        {
          id: 2,
          name: "访问远程服务",
          children: [
            {
              id: 201,
              parentid: 2,
              name: "NAS桌面",
            },
            {
              id: 202,
              parentid: 2,
              name: "远程路由",
            },
            {
              id: 203,
              parentid: 2,
              name: "远程桌面",
              children: [
                {
                  id: 20301,
                  parentid: 203,
                  name: "开启Windows远程桌面服务",
                },
                {
                  id: 20302,
                  parentid: 203,
                  name: "开启Mac远程桌面",
                },
                {
                  id: 20303,
                  parentid: 203,
                  name: "Windows访问Windows",
                },
                {
                  id: 20304,
                  parentid: 203,
                  name: "Windows访问Mac",
                },
                {
                  id: 20305,
                  parentid: 203,
                  name: "Mac访问Windows",
                },
                {
                  id: 20306,
                  parentid: 203,
                  name: "Mac访问Mac",
                },
              ],
            },
            {
              id: 204,
              parentid: 2,
              name: "远程开机",
            },
            {
              id: 205,
              parentid: 2,
              name: "远程下载",
            },
            {
              id: 206,
              parentid: 2,
              name: "Video Station",
            },
            {
              id: 207,
              parentid: 2,
              name: "Flie Station",
            },
            {
              id: 208,
              parentid: 2,
              name: "Synology Photos",
            },
            {
              id: 209,
              parentid: 2,
              name: "Jellyfin",
            },
            {
              id: 210,
              parentid: 2,
              name: "Emby",
            },
          ],
        },
        {
          id: 4,
          name: "工具箱",
          children: [
            {
              id: 401,
              parentid: 4,
              name: "相册备份",
            },
            {
              id: 402,
              parentid: 4,
              name: "小宝驿站",
            },
            {
              id: 403,
              parentid: 4,
              name: "宽带提速",
            },
            {
              id: 404,
              parentid: 4,
              name: "远程开机",
            },
          ],
        },
        // {
        //   id: 3,
        //   name: "高级功能",
        //   children: [],
        // },
      ],
      positionText: {}, //当前点击的导航栏
    };
  },
  methods: {
    remoteOpenClick: function () {
      let _that = this;
      _that.positionText = {
        id: 204,
        parentid: 2,
        name: "远程开机",
      };
    },
    vipGuideClick: function () {
      let _that = this;
      _that.positionText = _that.list[4];
    },
    nClick: function (item) {
      let _that = this;
      _that.positionText = item;
      document.getElementById("right").scrollTop = 0;
    },

    goClick: function () {
      this.$router.back(-1);
    },
  },
  activated() {
    let _that = this;
    _that.$store.state.expandedKeys = [];
    _that.$store.state.expandedKeys.push(5);
    _that.positionText = _that.list[0];
  },
};
</script>
<style lang="less" scoped>
.help {
  /*background-color: #f3f5f7;*/
}
.aboutJdxb-wrap {
  /*width: 960px;*/
  /*height: 510px;*/
  /*overflow: hidden;*/
  /*background-color: #f3f5f7;*/
}
.aboutJdxb {
  /*margin: 0 auto;*/
  /*width: 940px;*/
  /*height: 502px;*/
  /*box-sizing: border-box;*/
  /*background-repeat: no-repeat;*/
  /*background-size: 100% 100%;*/
  /*!*border: 1px solid #dddddd;*!*/
  /*border-radius: 4px;*/
  /*overflow: hidden;*/
  .about {
    /*width: 100%;*/
    /*height: 500px;*/
    /*!*overflow-y: scroll;*!*/
    /*background: linear-gradient(*/
    /*	180deg,*/
    /*	#ffffff 0%,*/
    /*	rgba(255, 255, 255, 0) 87.39%*/
    /*);*/

    .back {
      display: inline-block;
      padding-left: 22px;
      padding-top: 15px;
      padding-right: 22px;
      padding-bottom: 15px;
      vertical-align: top;
      font-size: 14px;
      line-height: 16px;
      color: #666666;
      cursor: pointer;
      .back-icon {
        display: inline-block;
        margin-right: 6px;
        vertical-align: top;
        width: 14px;
        height: 14px;
        background-image: url("../assets/remote/back.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .title {
      padding-top: 38px;
      height: 120px;
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #282938;
      background-image: url("../assets/answer/i1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: center;
      box-sizing: border-box;
    }
    .left {
      padding-top: 6px;
      margin-left: 12px;
      display: inline-block;
      vertical-align: top;
      width: 320px;
      box-sizing: border-box;

      .l-list {
        height: 480px;
        overflow-y: scroll;
        box-shadow: 0px 0px 7px rgba(123, 139, 172, 0.3);
        border-radius: 7px;
        box-sizing: border-box;
        background-color: #ffffff;
      }
      .l-list::-webkit-scrollbar {
        margin-right: 2px;
      }
      .l-list::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #e0e0e0;
      }
    }
    .right {
      display: inline-block;
      padding-top: 6px;
      padding-left: 40px;
      padding-right: 40px;
      vertical-align: top;
      width: 618px;
      height: 480px;
      overflow-y: scroll;
      box-sizing: border-box;

      .position-wrap {
        .position-text1 {
          margin-bottom: 10px;
          font-weight: 600;
          font-size: 24px;
          line-height: 48px;
          color: #000000;
        }
        .position-text2-wrap {
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #0176ff;
          .position-text2 {
            position: relative;
            padding-left: 10px;
            cursor: pointer;
            line-height: 32px;
          }
          .position-text2::before {
            position: absolute;
            top: 12px;
            left: 0;
            content: "";
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: #0176ff;
          }
        }
      }
    }
    .right::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>